export const createNestedData = arr => {
  const result = [];
  for (let i = 0; i < arr.length; i++) {
    arr[i].key = arr[i].id;
    result.push(arr[i]);
    let j = i + 1;
    while (j < arr.length) {
      if (!arr[j].id.includes(`${arr[i].id}.`)) {
        if (j > i + 1) {
          result[result.length - 1].children = createNestedData(
            arr.slice(i + 1, j)
          );
          i = j - 1;
        }
        break;
      }
      j++;
    }
    if (j >= arr.length) {
      result[result.length - 1].children = createNestedData(
        arr.slice(i + 1, j)
      );
      i = j - 1;
    }
  }
  return result;
};

export const convertToProperCase = text => {
  const result = text?.replace(/([A-Z])/g, " $1");
  return result?.charAt(0)?.toUpperCase() + result?.slice(1);
};
